<template>
	<div class="addresslist">
		<el-row style="padding-bottom:10px;">
			<el-col :span="12" style="color:#ffffff">占</el-col>
			<el-col :span="6"><el-input style="width:200px;margin-left:10px;" placeholder="输入关键词搜索" size="mini" type="text" v-model="addresskey" @input="addrsearch"></el-input></el-col>
		</el-row>
		<el-table :data="addresslist" height="400px" style="margin-top:0px;border-top:1px solid #e6e5de;" @cell-click="selectedaddr" empty-text="无符合条件的数据">
			<el-table-column label="地址信息" header-align="center">
				<template slot-scope="scope">
					<div style="font-weight:bold;font-size:12pt;padding-bottom:7px;">{{ scope.row.company }} {{ scope.row.name }}</div>
					<div>
					 Tel: {{ scope.row.phone }}
						<br />
					{{ scope.row.idcard }}	{{ scope.row.street }} {{ scope.row.detailaddr }} {{ scope.row.city }} {{ scope.row.province }} {{ scope.row.postcode }} {{ scope.row.country }}
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" :width="[addrtype=='1' ? '230px' : '80px']" header-align="center" align="right">
				<template slot-scope="scope">
					<div>
						<el-button type="danger" size="mini" @click="deladdr(scope.row)" style="margin-right:15px">删除</el-button>
						<el-switch size="mini" v-if="addrtype=='1'" v-model="scope.row.u_isdefault" :active-value="true"
					:inactive-value="false" active-color="#13ce66"
    inactive-color="#d9d9d9"  active-text="设为默认" @change="val=>setdefault(val, scope.row)" >
						</el-switch> 
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	props: {
		//地址类型 1-寄件地址 0-收件地址
		type: {
			type: String,
			default: ''
		},
		addrsearchkey:{
			type: String,
			default: ''
		},
		childrenindex:{
			type:Number,
			default:-1
		},
		modelindex:{
			type:Number,
			default:-1
		}
	},
	data() {
		return {
			addresskey: '',
			addrtype: '0',
			addresslist: [],
			mindex:-1,
			cindex:-1
		};
	},
	mounted() { 
		if (this.type != undefined) {
			this.addrtype = this.type;
		}
		if(this.addrsearchkey!=undefined){
			this.addresskey=this.addrsearchkey;
		}
		if(this.modelindex!=undefined)
			this.mindex=this.modelindex;
		if(this.childrenindex!=undefined)
			this.cindex=this.childrenindex;	
		this.getaddrlist();
	},
	methods: {
		//初始化
		init(param) {
			this.addrtype = param.type;
			this.addresskey = param.addresskey;
			this.cindex=param.childrenindex;
			this.mindex=param.modelindex;
			this.getaddrlist();
		},
		//获取地址库
		getaddrlist() {
			var that = this;
			var searchjson=[];
			that.addresslist=[];
			if(that.addresskey!='')
			{
				searchjson.push({col:'name',value:that.addresskey});
				searchjson.push({col:'phone',value:that.addresskey});
				searchjson.push({col:'country',value:that.addresskey});
				searchjson.push({col:'postcode',value:that.addresskey});
				searchjson.push({col:'city',value:that.addresskey});
				searchjson.push({col:'detailaddr',value:that.addresskey});
				searchjson.push({col:'province',value:that.addresskey});
				searchjson.push({col:'company',value:that.addresskey});
			}
			this.$tool.loading('正在搜索', 'addresslist');
			this.$apipost.get.GetAddresslist({ type: this.addrtype, searchjson: JSON.stringify(searchjson) }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.list.length > 0) {
						that.addresslist = res.list;
					}
				}
			});
		},
		//搜索地址库
		addrsearch(e){
			var that=this;
			setTimeout(function(){
				that.getaddrlist();
			},300);
		},
		//选中地址
		selectedaddr(row, column, cell, event){
			var that=this;
			if(column.label=='地址信息')
			{
				//回填，并关闭
				this.$emit('rebackaddr',
				{ 
					row:row,
					modelindex:that.mindex,
					childrenindex:that.cindex
				});
			}
		},
		//删除地址簿
		deladdr(row){
			var that=this;
			this.$confirm('确定删除此地址吗?', '提示', {
				cancelButtonText: '否',
				confirmButtonText: '是',
				type: 'warning',
				showClose: false,
				closeOnClickModal: false
			})
				.then(res => {
					if(res=='confirm'){
						this.$tool.loading('正在删除', 'addresslist');
						this.$apipost.post.DeleteAddr({ type: that.addrtype,addrid:row.id}).then(result => {
							this.$tool.loadingclose();
							if (result != '') {
								if(result.state=='1'){
									this.$tool.message('删除成功', 1);
									that.getaddrlist();
								}else{
									this.$tool.message('删除失败', 0);
								}
							} 
						});
					}
				})
				.catch(() => {
					
			 });
		},
		//设置地址为默认
		setdefault(val,row){
			var that=this;
			var isdefult=val.toString().toLowerCase();
			this.$tool.loading('正在设置', 'addresslist');
			this.$apipost.post.SetDefaultCtAddr({addrid:row.id,isdefault:isdefult}).then(result => {
				this.$tool.loadingclose();
				if (result != '') {
					if(result.state=='1'){
						this.$tool.message('设置成功', 1);
						that.getaddrlist();
					}else{
						this.$tool.message('设置失败', 0);
					}
				} 
			});
		}
	}
};
</script>
